import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PrintIcon from '@mui/icons-material/Print';
import MuiButton from "../../../shares/MuiButton";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import PanelTable from "../../../shares/PanelTable";
import OrderDetailsNew from "./OrderDetailsNew";
import AdminPrintNewOrderiInfo from "./AdminPrintNewOrderiInfo";
import RemoveOrder from "./RemoveOrder";


const headersList = [
  { colName: "name", name: "تولید کننده" },

  { colName: "unique_id", name: " سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "details", name: "جزییات سفارش" },
  // { colName: "details", name: "تایید سفارش" },
  { colName: "print", name: "چاپ سفارش" },
  { colName: "remove", name: "لغو سفارش" },

];
const mobileHeadersList = [
  { colName: "name", name: "تولید کننده" },
  { colName: "unique_id", name: " سند" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
];

const dataKey = [ "name","unique_id", "created_at", "total"];

const ProviderWaitingOrders = (props) => {
  let windowWidth = window.screen.width;

  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [brandFilter, setBrandFilter] = useState(null);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const { userData } = useUserData();
  const [storeFilter, setStoreFilter] = useState(null);

  const [brandsList, setBrandsList] = useState({ results: [] });
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "نام تولید کننده",
      label_en: "storeName",
      state: storeFilter,
    },
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const [waitingOrdersList, setWaitingOrdersList] = useState({ results: [] });

  const adminGetProviderCurrentOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/admin_get_waiting_provider_request`,
    params: {
      unique_id: codeFilter,
      date: dateFilter,
      provider_name: storeFilter,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setWaitingOrdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
    if (state == "storeName") setStoreFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (codeFilter !== null || dateFilter !== null || storeFilter !== null) {
      setIsFilterOn(true);
      setWaitingOrdersList({ results: [] });

      adminGetProviderCurrentOrderApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    setStoreFilter(null);

    adminGetProviderCurrentOrderApi.reFetch();
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setWaitingOrdersList({ results: [] });

    adminGetProviderCurrentOrderApi.reFetch();
  };

  const actionsList = [
    {
      label: 'چاپ',
      component: (it) => (
        <AdminPrintNewOrderiInfo inCurrentOrder selectedRow={it} />
      ),
    },
    {
      label: 'لغو سفارش',
      component: (it) => (
        <RemoveOrder
          selectedRow={it}
          adminGetProviderCurrentOrderApi={adminGetProviderCurrentOrderApi}
        />
      ),
    },
  ];

  const buttonsList = [
    {
      label: 'جزییات سفارش',
      component: (it) => (
        <OrderDetailsNew
          setNewOerdersList={setWaitingOrdersList}
          selectedRow={it}
          adminGetProviderCurrentOrderApi={adminGetProviderCurrentOrderApi}
        />
      ),
    },
    // {
    //   label: "تایید سفارش",
    //   component: (it) => (
    //     // <OrderDetails RemoveOrder selectedRow={it} data={waitingOrdersList} />
    //     <></>
    //   ),
    // },
  ];

  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-new-orders/${codeFilter}/${storeFilter}/${dateFilter}`
    // );
    window.open(
      `/print-providers-new-orders/${codeFilter}/${storeFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="p-waiting-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های منتظر تایید</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
           <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <PanelTable
            header="لیست سفارش‌های منتظر تایید:"
            headers={headersList}
            mobileHeaders={mobileHeadersList}
            data={waitingOrdersList.results}
            dataKey={dataKey}
            buttons={buttonsList}
            actions={actionsList}
            icon={<AccountBalanceIcon />}
          />
          <MuiPagination
            onChange={onChangePage}
            count={Math.ceil(
              paginationPageInfo.count / paginationPageInfo.pageSize
            )}
          />
        </>
      </PanelTemplate>
    </>
  );
};

export default ProviderWaitingOrders;
